// Shortcuts for common image kinds

export const BINARY = 'BINARY';
export const GREY = 'GREY';
export const GREYA = 'GREYA';
export const RGB = 'RGB';
export const RGBA = 'RGBA';
export const CMYK = 'CMYK';
export const CMYKA = 'CMYKA';
